import { render, staticRenderFns } from "./DataRiskReport.vue?vue&type=template&id=5f0ad960&"
import script from "./DataRiskReport.vue?vue&type=script&lang=js&"
export * from "./DataRiskReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports